const LockClosed = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M11.0312 14.5938C11.0312 14.8424 11.13 15.0808 11.3058 15.2567C11.4817 15.4325 11.7201 15.5312 11.9688 15.5312C12.2174 15.5312 12.4558 15.4325 12.6317 15.2567C12.8075 15.0808 12.9062 14.8424 12.9062 14.5938C12.9062 14.3451 12.8075 14.1067 12.6317 13.9308C12.4558 13.755 12.2174 13.6562 11.9688 13.6562C11.7201 13.6562 11.4817 13.755 11.3058 13.9308C11.13 14.1067 11.0312 14.3451 11.0312 14.5938Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M11.9688 15.5312V18.3438"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M4.9375 9.4375H19C19 9.4375 19.9375 9.4375 19.9375 10.375V21.625C19.9375 21.625 19.9375 22.5625 19 22.5625H4.9375C4.9375 22.5625 4 22.5625 4 21.625V10.375C4 10.375 4 9.4375 4.9375 9.4375Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M6.8125 6.15625C6.8125 4.78873 7.35575 3.47721 8.32273 2.51023C9.28971 1.54325 10.6012 1 11.9688 1C13.3363 1 14.6478 1.54325 15.6148 2.51023C16.5818 3.47721 17.125 4.78873 17.125 6.15625V9.4375H6.8125V6.15625Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default LockClosed;
